// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VwPCvWdlRojvCtPwr4Sr{bottom:0;left:0;position:fixed;right:0;top:0;z-index:1040}.lzur1Nu3s5TMjpsl61_5{background:rgba(0,0,0,0);border:none;position:absolute;right:10px;top:10px}.juxUmaYWkDoQ8YfFZolp{background-color:#fff;border-radius:5px;box-shadow:0 2px 4px rgba(0,0,0,.15);left:50%;max-height:calc(100vh - 120px);max-width:700px;overflow:scroll;padding:40px 50px;position:absolute;text-align:center;top:50%;transform:translate(-50%, -50%);width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `VwPCvWdlRojvCtPwr4Sr`,
	"buttonWrapper": `lzur1Nu3s5TMjpsl61_5`,
	"dialog": `juxUmaYWkDoQ8YfFZolp`
};
module.exports = ___CSS_LOADER_EXPORT___;
